import { createTrackingEvent } from '@/common/analytics/gtm/createTrackingEvent';

type InteractionType =
  | 'click'
  | 'hover'
  | 'scroll'
  | 'focus'
  | 'submit'
  | 'close'
  | 'expand'
  | 'swipe';

interface TrackElementInteractionProps {
  elementId: string;
  elementVariant?: string;
  interactionType?: InteractionType;
  shouldClearDataLayer?: boolean;
}

/**
 * GA4 tracking for 'element_interaction' event.
 */
export const trackElementInteraction = ({
  elementId,
  elementVariant = 'none',
  interactionType = 'click',
}: TrackElementInteractionProps) => {
  createTrackingEvent({
    event: 'element_interaction',
    element_id: elementId,
    element_variant: elementVariant,
    interaction_type: interactionType,
  });
};
